module.exports = __webpack_public_path__ + "img/20220412143916291tii.0a4b9046.jpg";